// extracted by mini-css-extract-plugin
export var container = "TableWrapper-module--container--4d18e";
export var scrollButton = "TableWrapper-module--scrollButton--d67a8";
export var scrollLeftButton = "TableWrapper-module--scrollLeftButton--70f4d";
export var scrollRightButton = "TableWrapper-module--scrollRightButton--8d624";
export var wrapper = "TableWrapper-module--wrapper--df733";
export var wrapperTouchscreen = "TableWrapper-module--wrapperTouchscreen--ae300";